module.exports = __webpack_public_path__ + "img/head_bj.2285738d.png";